import React,{Component} from 'react';
import {connect} from 'react-redux';
import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Button/Button';
import * as actions from '../../store/actions/index';
import Spinner from '../../components/UI/Spinner/Spinner';
import {Redirect} from 'react-router-dom';
import Classes from './Auth.css';
class Auth extends Component{
    state={
        controls:{
            email:{
                elementType:'input',
                elementConfig:{
                    type:'email',
                    placeholder:'Your Email'
                },
                value:'',
                validation:{
                    required:true,
                    isEmail:true
                },
                valid:false,
                touched:false
            },
            password:{
                elementType:'input',
                elementConfig:{
                    type:'password',
                    placeholder:'Your Password'
                },
                value:'',
                validation:{
                    required:true,
                    minLength:6
                },
                valid:false,
                touched:false
            }
        },
        isSignUp:true
    }

    componentDidMount(){
        if(!this.props.building){
            this.props.setAuthRedirectPath();
        }
    }

    onSubmitHandler=(event) => {
        event.preventDefault();
        this.props.onAuth(this.state.controls.email.value,this.state.controls.password.value,this.state.isSignUp);
    }
    
    checkValidity=(value,rules)=>{
        let isValid=true;
        if(rules.required){
            isValid=value.trim()!=='';
        }
        if(rules.isEmail){            // eslint-disable-next-line
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            isValid=re.test(String(value).toLowerCase());            
        }
        if(!isValid)            
            return isValid;
        if(rules.minLength){
            isValid=value.length>=rules.minLength;
        }
        if(!isValid)            
            return isValid;
        if(rules.maxLength){
            isValid=value.length<=rules.maxLength;
        }
        return isValid;           
            
    }
    switchAuthModeHandler=()=>{
        this.setState(prevState=>{
            return {isSignUp:!prevState.isSignUp}
        })
    }
    inputChangeHandler=(e)=>{
        let tempForm={...this.state.controls};
        tempForm[e.target.name].value=e.target.value;
        tempForm[e.target.name].touched=true;        
        if(tempForm[e.target.name].validation)
            tempForm[e.target.name].valid=this.checkValidity(e.target.value,tempForm[e.target.name].validation);
        this.setState({controls:tempForm});        
    }
    render(){
        let form=[] ;
        for(let key in this.state.controls){
            let each=this.state.controls[key];
            form.push(<Input changed={this.inputChangeHandler} key={key} name={key} {...each} />);
        }
        form=(<>
            <form onSubmit={this.onSubmitHandler}>
                {form}
                <Button type="Success">SUBMIT</Button>                
            </form>
            <Button type="Danger" clicked={this.switchAuthModeHandler}>SWITCH TO {this.state.isSignUp?'SIGN IN':'SIGN UP'}</Button>
            </>
        );

        if(this.props.loading){
            form=<Spinner/>;
        }

        let errorMessage=null;

        if(this.props.error){
            errorMessage=<h4>{this.props.error.message}</h4>;
        }
        let authRedirect=null;        
        if(this.props.isAuthenticated){
            authRedirect=<Redirect to={this.props.authRedirectPath} />
        }
        
        return (
            <div className={Classes.Auth}>
                {authRedirect}
                {errorMessage}
                {form}                                
            </div>
        )
    }
}

const mapStateToProps = state => {
    return{
        loading:state.auth.loading,
        error:state.auth.error,
        isAuthenticated:state.auth.token!==null,
        authRedirectPath:state.auth.authRedirectPath,
        building:state.burgerBuilder.building
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAuth:(email,password,isSignUp)=>dispatch(actions.auth(email,password,isSignUp)),
        setAuthRedirectPath:()=>dispatch(actions.setAuthRedirectPath("/"))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Auth);